import { render, staticRenderFns } from "./CustomActionSettings.vue?vue&type=template&id=21623f70&scoped=true&"
import script from "./CustomActionSettings.vue?vue&type=script&lang=js&"
export * from "./CustomActionSettings.vue?vue&type=script&lang=js&"
import style0 from "./CustomActionSettings.vue?vue&type=style&index=0&id=21623f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21623f70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21623f70')) {
      api.createRecord('21623f70', component.options)
    } else {
      api.reload('21623f70', component.options)
    }
    module.hot.accept("./CustomActionSettings.vue?vue&type=template&id=21623f70&scoped=true&", function () {
      api.rerender('21623f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/CustomActionSettings.vue"
export default component.exports